export const PERMISSION_MODULES = [
  { id: "pos", label: "Kasir / POS" },
  { id: "transactions", label: "Transaksi & retur" },
  { id: "receivables", label: "Piutang" },
  { id: "contacts", label: "Pelanggan" },
  { id: "suppliers", label: "Supplier" },
  { id: "products", label: "Produk & harga" },
  { id: "categories", label: "Kategori" },
  { id: "inventory", label: "Stok & opname" },
  { id: "warehouse", label: "Penerimaan gudang" },
  { id: "transfers", label: "Transfer stok" },
  { id: "purchases", label: "Pembelian" },
  { id: "reports", label: "Dashboard & laporan" },
  { id: "shifts", label: "Riwayat sif" },
  { id: "promotions", label: "Promosi" },
  { id: "payment_methods", label: "Metode pembayaran" },
  { id: "supervisor", label: "Persetujuan supervisor" },
];

export const ACCESS_PROFILES = {
  cashier: { label: "Kasir", role: "cashier", permissions: ["pos.read", "pos.write", "transactions.read"] },
  warehouse: { label: "Petugas Gudang", role: "warehouse", permissions: ["warehouse.read", "warehouse.write", "inventory.read", "inventory.write", "transfers.read", "transfers.write", "products.read"] },
  supervisor: { label: "Supervisor", role: "cashier", permissions: ["pos.read", "pos.write", "transactions.read", "receivables.read", "contacts.read", "products.read", "inventory.read", "warehouse.read", "transfers.read", "purchases.read", "reports.read", "shifts.read", "supervisor.read", "supervisor.write"] },
  auditor: { label: "Auditor (baca saja)", role: "cashier", permissions: ["transactions.read", "receivables.read", "contacts.read", "suppliers.read", "products.read", "inventory.read", "warehouse.read", "transfers.read", "purchases.read", "reports.read", "shifts.read"] },
};

const ROUTE_MODULES = [
  ["/pos", "pos"], ["/transactions", "transactions"], ["/piutang", "receivables"],
  ["/contacts", "contacts"], ["/suppliers", "suppliers"], ["/products", "products"], ["/barcode-pda", "products"],
  ["/categories", "categories"], ["/stok", "inventory"], ["/branch-stock", "inventory"],
  ["/stock-alerts", "inventory"], ["/warehouse", "warehouse"],
  ["/branch-transfers", "transfers"], ["/stock-requests", "transfers"],
  ["/purchases", "purchases"], ["/purchase-suggestions", "purchases"],
  ["/reports", "reports"], ["/dashboard", "reports"], ["/shifts", "shifts"], ["/supervisor", "supervisor"],
  ["/promotions", "promotions"], ["/payment-methods", "payment_methods"],
];

export function permissionForPath(pathname = "") {
  return ROUTE_MODULES.find(([path]) => pathname === path || pathname.startsWith(`${path}/`))?.[1] || null;
}

export function hasModuleAccess(user, module, action = "read") {
  if (!user || !module) return false;
  if (user.role === "admin") return true;
  if (user.permission_mode !== "custom") return false;
  const permissions = new Set(user.permissions || []);
  if (action === "delete") return permissions.has(`${module}.delete`);
  return permissions.has(`${module}.${action}`) || (action === "read" && permissions.has(`${module}.write`));
}

export function canAccessPath(user, pathname) {
  const module = permissionForPath(pathname);
  if (pathname === "/pos") return hasModuleAccess(user, "pos", "write");
  return module ? hasModuleAccess(user, module, "read") : user?.role === "admin";
}

export function isStoreAllowedForUser(user, storeId) {
  if (!user || !storeId) return false;
  if (!user.store_id || user.store_id === storeId) return true;
  return user.branch_scope === "selected" && (user.branch_store_ids || []).includes(storeId);
}
